import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralizeWithCount } from "@common/helpers/string";
import { useNormalizedDescriptions } from "@hooks/useNormalizedDescriptions";
import { useSelectedNormalizedDescriptionIds } from "@components/pageHeader/filters/Tabs/SimilarToFilter/useSelectedNormalizedDescriptionIds";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface Props {
    filters: Pick<
        FiltersTypes,
        "normalizedDescriptionId" | "normalizedDescriptionIds"
    >;
}

export const SimilarToFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data } = useNormalizedDescriptions();

    const selectedIds = useSelectedNormalizedDescriptionIds(
        filters,
        data?.mergedToCanonicalMap,
    );

    const label = useMemo(() => {
        if (selectedIds.length === 0) {
            return null;
        }

        if (selectedIds.length > 1) {
            return pluralizeWithCount("description group", selectedIds.length);
        }

        const description = data?.normalizedDescriptions.find(
            (item) => item.normalizedDescriptionId === selectedIds[0],
        );

        return (
            description?.sampleBankDescription ??
            description?.normalizedDescription ??
            selectedIds[0]
        );
    }, [data?.normalizedDescriptions, selectedIds]);

    if (!label) {
        return null;
    }

    return <BreakableText text={`Similar to ${label}`} showTooltip />;
};
